module.exports = __webpack_public_path__ + "img/sc1.f2abf40f.jpg";